<template>
  <section class="last-page" data-type="last-page">
    <div class="last-page__content" :class="productBrand.toLowerCase()">
      <div class="last-page__image__container">
      </div>
      <div class="last-page__info">
        <div>
          <img :src="brandLogo" width="250px">
          <div class="is-size-5 has-text-weight-bold mb-3">
            DO YOU HAVE ANY QUESTIONS?
          </div>
          <div class="is-size-6 has-text-weight-semibold">
            CONTACT US
          </div>
          <div>
            <div>
              <span class="icon">
                <i class="fas fa-phone"></i>
              </span>
              <span>{{ phone ? phone : '+1-416-497-7120' }}</span>
            </div>
            <div>
              <span class="icon">
                <i class="far fa-envelope"></i>
              </span>
              <span>{{ email }}</span>
            </div>
            <div>
              <span class="icon">
                <i class="fas fa-map-marker-alt"></i>
              </span>
              <span>41 Racine Rd. Toronto, ON M9W2Z4</span>
            </div>
            <div>
              <span class="icon">
                <i class="fas fa-globe"></i>
              </span>
              <span>mitrex.com</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- <section class="last-page__container" data-type="last-page">
    <template v-if="productBrand == 'Mitrex'">
      <div class="tagline">
        <span class="title is-2">
          Affordable integrated natural-looking Solar panels backed with Airspace Technology
        </span>
      </div>
      <img class="mb-5" src="@/assets/last_page_graphics.png"/>
      <div class="last-page__footer">
        Call: {{ phone }} | Email: {{ email }} | Address: 41 Racine Rd. Toronto, ON M9W2Z4
      </div>
    </template>
    <template v-else>
      <div class="tagline">
        <img class="mb-5 cladify-logo" src="@/assets/cladify_logo_lg.png" alt="cladify-logo"/>
        <div class="title is-4 title--cladify">
          A Global Innovator in Cladding Systems & Solutions
        </div>
        <p>
          Cladify has evolved from almost 20 years of perfecting the art and science of cladding; 
          first with stone, and now with a light weight, strong, and highly integrated, 
          composite panel cladding system. It’s designed to lower costs, 
          improve building performance, and increase design/application versatility 
          for new construction, renovations, and retrofits. The company is characterized 
          by relentless innovation, and continuous research and development to develop 
          better and more diverse cladding products to meet the aesthetic, functional, 
          and budgetary needs of our clients.
        </p>
      </div>
      <img
        class="mt-2"
        src="@/assets/about_cladify.png"
        alt="cladify cladding attributes"/>
      <div class="last-page__footer">
        Call: {{ phone }} | Email: {{ email }} | Address: 41 Racine Rd. Toronto, ON M9W2Z4
      </div>
    </template>
  </section> -->
</template>

<script>
export default {
  props: {
    productBrand: {
      type: String,
      required: true
    },
    phone: {
      type: [String, Number]
    },
    email: {
      type: [String, Number]
    }
  },
  computed: {
    brandLogo() {
      return this.productBrand == 'Cladify' ?
        require('@/assets/cladify_logo_white_white_sm.png') :
        require('@/assets/mitrex_logo_white_sm.png');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/last-page.scss';
</style>
